



































import * as Vue from '@vue/composition-api'
import DocsList from '@/components/DocsList.vue'

export default Vue.createComponent({
  name: 'Home',
  components: { DocsList },
  props: {},
  setup (props, ctx) {
    const onNew = async () => {
      await ctx.root.$store.dispatch('doc/createNew')
    }
    const snsContinueLogin = () => {
      ctx.root.$store.dispatch('user/snsLoginWithoutAnon')
    }
    const openDoc = (id: string) => {
      if (!id) { return }
      ctx.root.$router.push(`/editor/${id}`)
    }
    const docId = Vue.computed(() => {
      return ctx.root.$store.state.doc.docId
    })
    const isReady = Vue.computed(() => {
      return ctx.root.$store.state.doc.docState === 'ready'
    })
    const userDocs = Vue.computed(() => {
      return ctx.root.$store.state.doc.userDocs
    })
    const userEditingDocs = Vue.computed(() => {
      return userDocs.value.filter((item: any) => !item.isOrdered)
    })
    const userOrderedDocs = Vue.computed(() => {
      return userDocs.value.filter((item: any) => item.isOrdered)
    })
    const isAuthed = Vue.computed(() => {
      return ctx.root.$store.state.user.authorized
    })

    Vue.watch(() => {
      if (isReady.value) {
        ctx.root.$router.push(`/editor/${docId.value}`)
      }
    })

    return {
      onNew,
      snsContinueLogin,
      openDoc,
      docId,
      isReady,
      userEditingDocs,
      userOrderedDocs,
      isAuthed
    }
  }
})
